import {
  NoteStateMapV510,
  NoteStateV510,
} from 'src/common/store/migrate/types/5.1.0';
import { NotebookState } from 'src/common/store/notebook/NotebookState';
import { defaultVoiceboxSettings } from 'src/common/store/notebook/NoteState';
import { Preferences } from 'src/common/store/preferences/PreferencesState';
import { safelyGet } from 'src/common/utils/safelyGet';
import { InitialData } from 'src/types';

// eslint-disable-next-line import/no-default-export
export default (data: InitialData) => {
  const oldNotebook: Partial<NotebookState> = safelyGet(data, ['notebook'], {});
  const oldNotes: NoteStateMapV510 = safelyGet(oldNotebook, ['notes'], {});
  const newNotes: NoteStateMapV510 = Object.entries(oldNotes).reduce(
    (acc, [noteId, note]) => {
      const newNote: NoteStateV510 = {
        ...note,
        voiceboxSettings: { ...defaultVoiceboxSettings },
      };
      acc[noteId] = newNote;
      return acc;
    },
    {}
  );
  const preferences: Partial<Preferences & { defaultQueryPlanFormat: string }> =
    { ...(data?.preferences || {}) };
  delete preferences.defaultQueryPlanFormat;

  return {
    ...data,
    version: '3.10.6',
    notebook: {
      ...oldNotebook,
      notes: newNotes,
    },
    preferences,
  };
};
